//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    function checkDigitsCount(value, length) {
        let val = "";
        if (value) val = value;

        return val.replace(/\D/g, '').length == length;
    }

    let validationRules = {
        requiredPhone: value => !!value || 'Введите номер телефона',
        requiredCode: value => !!value || 'Заполните поле',
        phoneFirstDigitIs9:
            (
                value,
                pattern = /^(\+7 9)./
            ) =>
                pattern.test(value) || 'Номер должен начинаться с 9',
        phone: value => checkDigitsCount(value, 11) || 'Введите номер телефона',
        code:  value => checkDigitsCount(value, 5) || 'СМС код введен не полностью',
        requiredAutocomplete: (value) => !!value || 'Укажите фамилию, имя и отчество',
        fio: (value) => value.split(' ').length > 2 || 'Укажите \'Нет\', если отчество отсутствует',

    };
    const VR = validationRules;
    let cleanRules = {
        phone(str) {
            return str.replace('+7', '').replace(/\s+/g, '');
        },
        getDigits(str) {
            return str.replace(/\D/g, '');
        },
    };

    const CR = cleanRules;

    import Field from "../components/controls/Field.vue"
    import textField from '../components/controls/Text.vue'
    import autoComplite from '../components/controls/Autocomplete.vue'
    import timer from '../components/controls/Timer.vue'
    import LoadBtn from '../components/controls/LoadButton.vue'
    import VueRecaptcha  from 'vue-recaptcha';

    import * as API from "../components/api.js";

    export default {
        components: {
            'field': Field,
            textField, timer,
            'btn':LoadBtn,
            VueRecaptcha,
            autoComplite
        },
        computed:{
            agreeInfo() {
                return {
                    link: 'https://fin-connect.ru/document'
                }
            },
        },
        created(){
            let url_string = window.location.href;
            let url = new URL(url_string);
            this.requestId=process.env.NODE_ENV === 'production' ? url.searchParams.get("token"): 'f24b87dd';
        },
        data() {
            return {
                requestId:null,
                token:null,
                fields: {
                    phone: {
                        value: '',
                        cleanValue() {
                            return CR.phone(this.value);
                        },
                        label: "Номер телефона",
                        disabled: false,
                        error: false,
                        mask: '+7 ### ### ## ##',
                        type: "tel",
                        rules: [
                            VR.requiredPhone,
                            VR.phoneFirstDigitIs9,
                            VR.phone,
                        ]
                    },
                    code: {
                        value:'',
                        label: "Код из СМС",
                        mask: '#####',
                        type: "tel",
                        isVisible:false,
                        focus:false,
                        disabled:false,
                        error:false,
                        errorText:"",
                        rules: [
                            VR.requiredCode,
                            VR.code
                        ],
                        input: value => {
                            if ( VR.code(value) === true
                            ) {
                                this.checkCode(this.fields.code.value);
                            }
                        },


                    },
                    fio: {
                        label: 'Фамилия Имя Отчество',
                        value: '',
                        fieldType: 'autocomplete',
                        'item-text': 'value',
                        items: [],
                        // autoFill: false,
                        placeholder: 'Иванова Татьяна Александровна',
                        isCyrilic: true,
                        rules: [
                            VR.requiredAutocomplete,
                            VR.fio
                        ],
                        search: (value) => {
                            API.searchFIO(value).then((data) => {
                                let suggestions = data.FIO
                                    .filter((item) => !!item.lastName)
                                    .map((item) => ({
                                        value: [
                                            item.lastName,
                                            item.firstName,
                                            item.middleName,
                                        ]
                                            .join(' ')
                                            .trim(),
                                    }));

                                this.fields.fio.items = [{ value }, ...suggestions];
                                this.fields.fio.value = this.fields.fio.items[0].value;
                            });
                        },
                        setValue( value ) {
                            this.items = [{value}];
                            this.value = value;
                        }
                    },
                    validatedDoc: () => {
                        if(this.listOfScans){
                            let fields;
                            fields = Object.keys(this.listOfScans)
                                .filter(key => !!this.listOfScans[key].isChange);
                            return fields.length==this.listOfScans.length
                        }
                        return false
                    },

                },
                timer:{
                    seconds:1.5 * 60 * 1000,
                    key:0,
                    visible: false,
                    reload:()=>{
                        this.timer.visible=true;
                        this.timer.key++
                    },
                    complete: () => {
                        this.timer.visible = false;
                        if( this.countSendSms>=0){
                            this.disabledResendBtn = false;
                        }

                    }
                },
                countSendSms:3,
                countCheckCode:3,
                showError: false,
                disabledResendBtn: true,
                checkSmsWait:false,
                oldSMSVal:'',
                endPoint:false,
                textError:'Ошибка при запросе, повторите запрос позже',
                loaderBtn:{
                    sendSMS: false,
                    resendSMS: false,
                    sendDoc: false
                },
                recaptchaToken:null

            }
        },
        methods: {
            sendSMS(recaptchaToken) {
                    this.loaderBtn.sendSMS=true;
                    var sourceFio = this.fields.fio.value.trim().split(" ");
                    let sendObj={
                        client: {
                            "lastName": sourceFio[0],
                            "firstName": sourceFio[1],
                            "middleName": sourceFio[2],
                            "mobilePhone": this.fields.phone.cleanValue()
                        },
                        RecaptchaResponse:recaptchaToken
                    };
                    this.resetErrorMessage();
                    API.createApp(this.requestId,sendObj).then(response =>{
                            this.loaderBtn.sendSMS=false;
                            if(response.isSuccess){
                                this.timer.reload();
                                this.fields.code.isVisible=true;
                                this.fields.code.focus=true;
                                this.token=response.onlineToken;
                            }
                            else{
                                if(response.errorCode ==5){
                                    this.setErrorMessage("Заявка с данным номером телефона уже создана.Ожидайте звонка специалиста");
                                }
                                else{
                                    this.setErrorMessage("Ошибка при запросе, повторите позже");
                                }

                            }
                    }

                    ).catch(error=>{
                        this.setErrorMessage("Ошибка при запросе, повторите позже");
                        this.loaderBtn.sendSMS=false;
                        console.log(error);
                    });


            },
            resendSendSMS(){
                this.loaderBtn.resendSMS=true;
                if(this.countSendSms>0){
                    this.disabledResendBtn=true;
                    this.resetErrorMessage();
                    let resendObj={
                        "MobilePhone": this.fields.phone.cleanValue()
                    };
                    this.countSendSms--;
                    API.sendSMS(this.token,resendObj).then(response=>{
                        this.loaderBtn.resendSMS=false;
                        if(response.isSuccess){
                            this.fields.code.focus=true;
                            this.fields.code.disabled=false;
                            this.countCheckCode=3;
                            this.fields.code.value="";
                            this.timer.reload();
                        }
                        else{
                            this.setErrorMessage('Ошибка при запросе, повторите запрос позже');
                        }

                    }).catch(error=>{
                        this.disabledResendBtn=false;
                        this.showError=true;
                        this.setErrorMessage('Ошибка при запросе, повторите запрос позже');
                        console.log(error);
                    })
                }
                else{
                    this.setErrorMessage('Количество попыток ввода кода исчерпано. Обратитесь повторно через 24 часа.');
                    this.disabledResendBtn=true;
                    this.fields.code.disabled=true;
                }

            },
            checkCode(code){
                if (this.checkSmsWait  || code===this.oldSMSVal) {
                    return;
                }
                this.checkSmsWait = true;
                this.resetErrorMessage();
                this.countCheckCode--;
                if(this.countCheckCode<0){
                    this.countCheckCode=0
                }

                if ( this.countCheckCode == 0 ) {
                    this.fields.code.disabled = true;
                    this.setErrorMessage('Количество попыток проверок кода исчерпано, переотправьте смс');
                    this.fields.code.value='';
                    return
                }
                this.fields.code.disabled=true;
                this.fields.code.error=false;
                let sendCodeObj={
//                    "Code": process.env.NODE_ENV === 'production' ?  code : '12345'
                    "Code":code
                };
                if( this.countCheckCode>=0){
                    API.checkSMS(this.token, sendCodeObj).then(response=>{
                        if(response.isSuccess && response.checkCode){
                            this.resetErrorMessage();
                            API.sendApp(this.token).then(response=>{
                                if(response.isSuccess){
                                    this.endPoint=true;
                                }
                                else{
                                    this.setErrorMessage('Ошибка при запросе, повторите запрос позж');
                                }
                            }).catch(error=>{
                                console.log(error);
                            });
                        }
                        else{
                            console.log("here");
                            this.fields.code.error=true;
                            this.oldSMSVal=code;
                            this.checkSmsWait=false;
                            this.setErrorMessage('Код не верен');
                            this.fields.code.disabled=false;
//
                        }


                    }).catch(error=>{
                        this.fields.code.error=true;
                        this.checkSmsWait=false;
                        this.oldSMSVal=code;
                        this.setErrorMessage('Ошибка при запросе, повторите запрос позже');
                        this.fields.code.disabled=false;
                        console.log(error)
                    });
                }



            },
            verifyMethod(val){
                this.recaptchaToken=val;
                this.sendSMS(val);
            },
            onCaptchaExpired () {
                this.$refs.recaptcha.reset()
            },
            setErrorMessage(textError){
                this.textError = textError;
                this.showError=true;
            },
            resetErrorMessage(){
                this.textError = "";
                this.showError=false;
            },
            fireCaptcha(){
                if ( this.$refs.form.validate() ) {
                    this.$refs.recaptcha.execute()
                }
            }
        },

    }
